import React, { Component } from 'react';
import PropTypes from 'prop-types';
import strings from '../locales/';
import utilFunction from '../../containers/function';
import constants from '../../containers/function/constants';
import { Checkbox } from 'react-bootstrap';

class FlowsTable extends Component {
  constructor(props) {
    super(props);
  }
  
  checkButtonActive = (id) => {
    if(this.props.flowsToSend[String(id)]) {
      return true;
    }
    return false;
  };

  render() {
    return (
    	<section className="flows-table">
        <table className="flows-table-fixed-part">
          <thead>
            <tr>
              <th className="flows-table-th send-th">{"Seleccionar para enviar"}</th>
              <th className="flows-table-th options-th">{"Opciones"}</th>
            </tr>
          </thead>
          <tbody>
            {
              this.props.data &&
                this.props.data.map((item, i)=>(
                  <tr key={`t-flows-table-${i}`} className={"state-" + item.flowRequestState.toLowerCase()}>
                    <td className="flows-table-td send-td"><div>
                      <Checkbox 
                        inline
                        data-action={"SendApplicant"}
                        data-datos={JSON.stringify(item)}
                        value={this.checkButtonActive(item.id)}
                        checked={this.checkButtonActive(item.id)}
                        onChange={this.props.handleClickToogleToSend}
                      />
                    </div></td>
                    <td className="flows-table-td options-td"><div>
                      <div className={"box-form"}>
                        <div className={"normal_button edit-flow"}>
                          <div
                            data-datos={JSON.stringify(item)}
                            onClick={this.props.handleClickEdit}
                            className="fas fa-edit"
                          />
                        </div>
                      </div>
                    </div></td>
                  </tr>
                ))
            }
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th className="flows-table-th state-th">{"Estado"}</th>
              <th className="flows-table-th vehicle-th">{"Vehículo"}</th>
              <th className="flows-table-th vehicle-type-th">{"Tipo de Vehículo"}</th>
              <th className="flows-table-th semitrailer-th">{"Rampla"}</th>
              <th className="flows-table-th moppermit-th">{"Permiso MOP"}</th>
              <th className="flows-table-th mopfile-th">{"Archivo MOP"}</th>
              <th className="flows-table-th escort-th">{"Escolta"}</th>
              <th className="flows-table-th driver-th">{"Conductor"}</th>
              <th className="flows-table-th management-th">{"Gerencia"}</th>
              <th className="flows-table-th load-th">{"Carga"}</th>
              <th className="flows-table-th direction-th">{"Sentido"}</th>
              <th className="flows-table-th date-th">{"Fecha"}</th>
              <th className="flows-table-th time-th">{"Hora"}</th>
              <th className="flows-table-th comments-th">{"Comentarios"}</th>
            </tr>
          </thead>
          <tbody>
            {
              this.props.data &&
                this.props.data.map((item, i)=>(
                  <tr key={`t-flows-table-${i}`} className={"state-" + item.flowRequestState.toLowerCase()}>
                    <td className="flows-table-td state-td"><div>
                      {this.props.language.flows.states[item.flowRequestState.toLowerCase()]}
                    </div></td>
                    <td className="flows-table-td vehicle-td"><div>{item.vehicleAlias}</div></td>
                    <td className="flows-table-td vehicle-type-td"><div>{item.vehicleType}</div></td>
                    <td className="flows-table-td semitrailer-td"><div>{item.semiTrailerAlias}</div></td>
                    <td className="flows-table-td moppermit-td"><div>{item.mopPermit}</div></td>
                    <td className="flows-table-td mopfile-td"><div>
                      {item.mopPermitFiles && item.mopPermitFiles!="" && 
                        item.mopPermitFiles.split("|").map(item => {
                          if(item!="") {
                            return (
                              <div 
                                data-path={JSON.stringify(item)}
                                key={item} 
                                onClick={this.props.handleDownloadMopFile}    
                                className="fas fa-file"
                              />
                            );
                          }
                          return null;
                        })
                      }
                    </div></td>
                    <td className="flows-table-td escort-td"><div>{item.escort}</div></td>
                    <td className="flows-table-td driver-td"><div>{item.personAlias}</div></td>
                    <td className="flows-table-td management-td"><div>{item.management}</div></td>
                    <td className="flows-table-td load-td"><div>{item.load}</div></td>
                    <td className="flows-table-td direction-td"><div>{item.direction}</div></td>
                    <td className="flows-table-td date-td"><div>
                      {(utilFunction.getFormatFunction({type:"DATE_TIME_PARSE_ISO",format:"%d-%m-%Y"}))(
                          (item.date + "T12:00:00.000+0000")
                        )}
                    </div></td>
                    <td className="flows-table-td time-td"><div>{item.time}</div></td>
                    <td className="flows-table-td comments-td options-td"><div>
                      <div className={"box-form"}>
                        {item.comments!="" && (
                          <div className={"normal_button comments-flow "}>
                            <div
                              data-datos={JSON.stringify(item.comments)}
                              onClick={this.props.handleModalViewComments}
                            >
                              {"Ver"}
                            </div>
                          </div>
                        )}
                      </div>
                    </div></td>
                  </tr>
                ))
            }
          </tbody>
        </table>
      </section>
    );
  }
}

export default FlowsTable;



// WEBPACK FOOTER //
// ./source/client/components/flow_applicant_detail/flowsTable.jsx